module.exports = __webpack_public_path__ + "img/risk-list.e0f29be8.png";